export default function Download({ className = "", fill = "#101010" }) {
  return (
    <svg
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill={fill}>
      <g stroke="none" strokeWidth="1" fillRule="evenodd">
        <g transform="translate(-1008.000000, -730.000000)">
          <g id="Group-8" transform="translate(70.000000, 271.000000)">
            <g id="Group-10" transform="translate(724.000000, 136.000000)">
              <g id="Group-20" transform="translate(0.000000, 308.000000)">
                <path d="M216.222222,22.7777778 L216.222222,32.7777778 L231.777778,32.7777778 L231.777778,22.7777778 L234,22.7777778 L234,35 L214,35 L214,22.7777778 L216.222222,22.7777778 Z M225.111111,15 L225.111444,22.777 L228.444444,22.7777778 L224,28.3333333 L219.555556,22.7777778 L222.889444,22.777 L222.888889,15 L225.111111,15 Z"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
